var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var MobileRoomPanel = require('./_room-panel');

        var HotelRoomInfoModal = function () {
            function HotelRoomInfoModal(params) {
                _classCallCheck(this, HotelRoomInfoModal);

                this.roomsInfo = params.rooms;
                this.eventPage = params.eventPage;

                this.roomImageSlider = null;
                this.handlers();
            }

            _createClass(HotelRoomInfoModal, [{
                key: "handlers",
                value: function handlers() {
                    var _this = this;

                    eventDispatcher.on('click', '.js-toggle-all-room-modal', function (event, element) {
                        var index = element.dataset.index;
                        _this.renderModalContent(index);
                    });
                }
            }, {
                key: "getRoomInfoById",
                value: function getRoomInfoById(id) {
                    return this.roomsInfo.find(function (room) {
                        return room.id == id;
                    });
                }
            }, {
                key: "renderModalContent",
                value: function renderModalContent(index) {
                    var panel = new MobileRoomPanel(window.mobileRoomLabels);
                    panel.open(this.roomsInfo, this.roomsInfo.findIndex(function (room) {
                        return room.id == index;
                    }));
                }
            }, {
                key: "initRoomSlider",
                value: function initRoomSlider() {
                    var params = {
                        freeMode: false,
                        loop: false,
                        slidesPerView: 1,
                        pagination: {
                            el: '.swiper-pagination'
                        },
                        navigation: {
                            nextEl: null,
                            prevEl: null
                        }
                    };
                    this.roomImageSlider = new Swiper('#roomImages', params);
                }
            }, {
                key: "renderRoomImagesSlider",
                value: function renderRoomImagesSlider(photos) {
                    if (!photos || photos.length === 0) {
                        return '';
                    }
                    var slides = photos.map(function (photo) {
                        return "\n            <div class=\"swiper-slide\">\n                <img src=\"" + photo + "\" alt=\"Room Image\">\n            </div>";
                    }).join('');

                    return "\n            <div id=\"roomImages\" class=\"swiper\">\n                <div class=\"swiper-wrapper\">\n                    " + slides + "\n                </div>\n                <div class=\"swiper-pagination\"></div>\n            </div>";
                }
            }, {
                key: "renderNoImagePlug",
                value: function renderNoImagePlug() {
                    return "\n            <img class=\"no-image-room\" src=\"/x-assets/img/no-image.svg\" alt=\"no-image-plug\">";
                }
            }, {
                key: "renderRoomName",
                value: function renderRoomName(name) {
                    return "<div class=\"room-name\">" + name + "</div>";
                }
            }, {
                key: "renderRoomArea",
                value: function renderRoomArea(area) {
                    if (!area) {
                        return '';
                    }
                    return "<div class=\"room-area\">" + area + " \u043C<sup>2</sup></div>";
                }
            }, {
                key: "renderRoomDescription",
                value: function renderRoomDescription(description) {
                    if (!description) {
                        return '';
                    }
                    return "<div class=\"room-description\">" + description.replace(/\n/g, '<br>') + "</div>";
                }
            }]);

            return HotelRoomInfoModal;
        }();

        var HotelRoomsSlider = function () {
            function HotelRoomsSlider(params) {
                _classCallCheck(this, HotelRoomsSlider);

                this.roomsInfo = params.rooms;
                this.eventPage = params.eventPage;
                this.swiper = null;
                this.swipeCount = 0;
                this.init();
            }

            _createClass(HotelRoomsSlider, [{
                key: "init",
                value: function init() {
                    var self = this;
                    var params = {
                        lazy: true,
                        preloadImages: false,
                        loadOnTransitionStart: true,
                        lazyPreloadPrevNext: 2,
                        freeMode: false,
                        loop: false,
                        slidesPerView: 1.3,
                        spaceBetween: 20,
                        navigation: {
                            nextEl: null,
                            prevEl: null
                        },
                        breakpoints: {
                            500: {
                                slidesPerView: 2.3
                            },
                            650: {
                                slidesPerView: 2.6
                            },
                            800: {
                                slidesPerView: 3.3
                            }
                        },
                        on: {
                            slideChange: function slideChange() {
                                var eventProperties = {};
                                eventProperties['Page'] = self.eventPage;
                                window.brxTracking.sendAnalyticsEvent('scroll_hotel_rooms', eventProperties);
                                this.off('slideChange');
                            },
                            click: function click() {
                                var eventProperties = {};
                                eventProperties['Page'] = self.eventPage;
                                window.brxTracking.sendAnalyticsEvent('click_hotel_room_type', eventProperties);
                                this.off('click');
                            }
                        }
                    };
                    this.swiper = new Swiper('#hotelRoomsSwiper', params);

                    this.hotelRoomInfoModal = new HotelRoomInfoModal({
                        rooms: this.roomsInfo,
                        eventPage: this.eventPage
                    });
                }
            }]);

            return HotelRoomsSlider;
        }();

        window.HotelRoomsSlider = HotelRoomsSlider;
    }, { "./_room-panel": 2 }], 2: [function (require, module, exports) {
        /* jshint esversion: 6 */
        var MobileRoomPanel = function () {
            function MobileRoomPanel(labels) {
                _classCallCheck(this, MobileRoomPanel);

                this.labels = labels;
            }

            _createClass(MobileRoomPanel, [{
                key: "element",
                value: function element(tag, className) {
                    var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

                    var node = document.createElement(tag);
                    node.className = className;node.textContent = text;return node;
                }
            }, {
                key: "open",
                value: function open(variants, selectedIndex) {
                    var _this2 = this;

                    var bookingUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    var split = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

                    var root = this.element('div', 'mobile-room-panel');
                    var navigation = this.element('div', 'mobile-room-panel__tabs');
                    navigation.setAttribute('role', 'tablist');
                    navigation.setAttribute('aria-label', this.labels.title);
                    variants.forEach(function (variant, index) {
                        var option = _this2.element('button', 'mobile-room-panel__tab', variant.name);
                        option.type = 'button';
                        option.setAttribute('role', 'tab');
                        option.addEventListener('click', function () {
                            return show(index, true);
                        });
                        navigation.appendChild(option);
                    });
                    var body = this.element('div', 'mobile-room-panel__body');
                    var action = bookingUrl && !split ? this.element('div', 'mobile-room-panel__action') : null;
                    root.appendChild(navigation);root.appendChild(body);
                    var gallery = null,
                        modal = null,
                        activeIndex = null;
                    var show = function show(index) {
                        var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                        if (activeIndex === index) return;
                        if (animate) {
                            var _variant = variants[index];
                            if (window.brxTracking) window.brxTracking.sendAnalyticsEvent('hotel_room_change', Object.assign({}, window.app && window.app.pageParams, {
                                context: bookingUrl ? 'booking' : 'hotel', room_id: _variant.detail ? _variant.detail.id : _variant.id,
                                tour_id: _variant.tourId, room_index: index
                            }));
                        }
                        activeIndex = index;
                        if (gallery) {
                            gallery.destroy(true, true);gallery = null;
                        }
                        Array.from(navigation.children).forEach(function (tab, tabIndex) {
                            tab.setAttribute('aria-selected', String(tabIndex === index));
                        });
                        var activeTab = navigation.children[index];
                        var tabInset = parseFloat(window.getComputedStyle(navigation).paddingLeft);
                        navigation.scrollTo({
                            left: navigation.scrollLeft + activeTab.getBoundingClientRect().left - navigation.getBoundingClientRect().left - tabInset,
                            behavior: animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
                        });
                        body.replaceChildren();
                        var variant = variants[index];
                        var room = bookingUrl || split ? variant.detail : variant;
                        var card = _this2.element('article', 'mobile-room-panel__card');
                        var heading = _this2.element('div', 'mobile-room-panel__heading');
                        var title = _this2.element('div', 'mobile-room-panel__title');
                        title.appendChild(_this2.element('h2', '', variant.name));
                        if (room && room.area) title.appendChild(_this2.element('p', 'mobile-room-panel__area', room.area + ' ' + _this2.labels.area));
                        heading.appendChild(title);
                        if (action && index === 0) {
                            heading.appendChild(_this2.element('span', 'mobile-room-panel__current', _this2.labels.selected));
                        }
                        if (action && index !== 0 && variant.diff) {
                            heading.appendChild(_this2.element('strong', 'mobile-room-panel__price', variant.diff));
                        }
                        card.appendChild(heading);
                        var slider = void 0;
                        if (room && room.photos && room.photos.length) {
                            slider = _this2.element('div', 'swiper mobile-room-panel__gallery');
                            var slides = _this2.element('div', 'swiper-wrapper');
                            room.photos.forEach(function (src) {
                                var slide = _this2.element('div', 'swiper-slide');
                                var image = _this2.element('img', '');image.src = src;image.alt = variant.name;image.loading = 'lazy';
                                slide.appendChild(image);slides.appendChild(slide);
                            });
                            slider.appendChild(slides);slider.appendChild(_this2.element('div', 'swiper-pagination'));
                            card.appendChild(slider);
                        }
                        if (room) {
                            var services = (room.services || []).filter(function (service) {
                                return service.value && !/^(нет|no|false|0)$/i.test(String(service.value).trim());
                            });
                            var description = room.description || '';
                            if (services.length) description = description.split(/Удобства в номере\s*:/i)[0].trim();
                            if (description) card.appendChild(_this2.element('div', 'mobile-room-panel__description', description));
                            _this2.appendServices(card, services, _this2.labels.amenities);
                            var additional = Object.values(room.additionalServices || {}).map(function (name) {
                                return { name: name, value: 'есть' };
                            });
                            _this2.appendServices(card, additional, _this2.labels.additional);
                        }
                        body.appendChild(card);
                        if (action) {
                            action.replaceChildren();
                            action.hidden = index === 0;
                            if (index !== 0) {
                                var link = _this2.element('a', 'btn btn-blue btn-select-room', _this2.labels.select);
                                link.href = bookingUrl + '/' + encodeURIComponent(variant.tourId) + window.location.search;
                                action.appendChild(link);
                            }
                        }
                        if (slider) gallery = new Swiper(slider, { slidesPerView: 1, pagination: { el: slider.querySelector('.swiper-pagination'), type: 'fraction' } });
                        if (modal) modal.querySelector('.modal2-body').scrollTop = 0;
                    };
                    window.modal.open({
                        header: { title: this.labels.title, theme: window.modal.themes.PRIMARY },
                        type: 'full', footer: false, parentCssClass: 'mobile-room-panel-modal', content: { html: root },
                        onAfterShow: function onAfterShow(element) {
                            modal = element;
                            if (action) modal.querySelector('.modal2-content').appendChild(action);
                            show(selectedIndex);
                        },
                        onBeforeRemove: function onBeforeRemove() {
                            if (gallery) gallery.destroy(true, true);
                        }
                    });
                }
            }, {
                key: "appendServices",
                value: function appendServices(card, services, title) {
                    var _this3 = this;

                    if (!services.length) return;
                    var section = this.element('section', 'mobile-room-panel__services');
                    section.appendChild(this.element('h3', '', title));
                    var list = this.element('ul', 'mobile-room-panel__list');
                    services.forEach(function (service) {
                        var row = _this3.element('li', 'mobile-room-panel__service');
                        row.appendChild(_this3.element('span', '', service.name));
                        var value = String(service.value).trim();
                        if (/^(платно|бесплатно)$/i.test(value)) {
                            var paid = value.toLowerCase() === 'платно';
                            row.appendChild(_this3.element('span', 'mobile-room-panel__badge' + (paid ? ' mobile-room-panel__badge--paid' : ''), paid ? _this3.labels.paid : _this3.labels.free));
                        } else if (!/^(есть|yes|true|1)$/i.test(value)) {
                            row.appendChild(_this3.element('span', 'mobile-room-panel__value', value));
                        }
                        list.appendChild(row);
                    });
                    section.appendChild(list);
                    card.appendChild(section);
                }
            }]);

            return MobileRoomPanel;
        }();

        module.exports = MobileRoomPanel;
    }, {}], 3: [function (require, module, exports) {
        var MobileRoomPanel = require('./parts/_room-panel');
        /* jshint esversion: 6 */

        var AllHotelRooms = require('./parts/_all-hotel-rooms');

        var RoomsSlider = function () {
            function RoomsSlider(params) {
                _classCallCheck(this, RoomsSlider);

                this.roomsWidgetType = params.roomsWidgetType;
                this.swiper = null;
                this.swipeCount = 0;
                this.init();
            }

            _createClass(RoomsSlider, [{
                key: "init",
                value: function init() {
                    var self = this;
                    var params = {
                        freeMode: false,
                        loop: false,
                        slidesPerView: 1.2,
                        spaceBetween: 0,
                        navigation: {
                            nextEl: null,
                            prevEl: null
                        },
                        on: {
                            slideChange: function slideChange() {
                                if (!self.swipeCount) {
                                    self.swipeCount = 1;
                                }
                            }
                        }
                    };

                    if (this.roomsWidgetType === 'view-split-rooms') {
                        params.direction = 'vertical';
                        params.slidesPerView = 2;
                        params.allowTouchMove = false;
                        params.simulateTouch = false;
                        params.touchStartPreventDefault = false;
                    }

                    this.swiper = new Swiper('#roomListSwiper', params);
                }
            }]);

            return RoomsSlider;
        }();

        var RoomModal = function () {
            function RoomModal(params) {
                _classCallCheck(this, RoomModal);

                this.loadRoomModalContent = params.loadRoomModalContent ? params.loadRoomModalContent : null;
                this.newTourUrl = params.newTourUrl ? params.newTourUrl : null;
                this.modal = window.modal;
                this.roomImageSlider = null;
                this.roomsWidgetType = params.roomsWidgetType;

                this.handlers();
            }

            _createClass(RoomModal, [{
                key: "handlers",
                value: function handlers() {
                    var _this4 = this;

                    eventDispatcher.on('click', '.js-toggle-room-modal', function (event, element) {
                        var index = element.dataset.index;
                        var eventProperties = {};
                        eventProperties['Place'] = _this4.roomsWidgetType;
                        window.brxTracking.sendAnalyticsEvent('click_on_hotel_room', eventProperties);
                        _this4.renderModalContent(index);
                    });

                    eventDispatcher.on('click', '.btn-select-room', function (e, element) {
                        var eventProperties = {};
                        eventProperties['Place'] = _this4.roomsWidgetType;
                        window.brxTracking.sendAnalyticsEvent('click_to_select_hotel_room', eventProperties);
                        eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: element,
                            isShow: true
                        });
                        eventDispatcher.dispatchEvent('_block-page');
                    });
                }
            }, {
                key: "renderModalContent",
                value: function renderModalContent(index) {
                    var keys = Object.keys(window.rooms).filter(function (key) {
                        return window.rooms[key];
                    });
                    var panel = new MobileRoomPanel(window.mobileRoomLabels);
                    panel.open(keys.map(function (key) {
                        return window.rooms[key];
                    }), keys.indexOf(String(index)), this.newTourUrl, this.roomsWidgetType === 'view-split-rooms');
                }
            }, {
                key: "initRoomSlider",
                value: function initRoomSlider() {
                    var params = {
                        freeMode: false,
                        loop: false,
                        slidesPerView: 1,
                        pagination: {
                            el: ".swiper-pagination"
                        },
                        navigation: {
                            nextEl: null,
                            prevEl: null
                        }
                    };
                    this.roomImageSlider = new Swiper('#roomImages', params);
                }
            }, {
                key: "renderRoomImagesSlider",
                value: function renderRoomImagesSlider(photos) {
                    if (photos.length === 0) {
                        return;
                    }
                    var slides = photos.map(function (photo) {
                        return "\n        <div class=\"swiper-slide\">\n            <img src=\"" + photo + "\" alt=\"Room Image\">\n        </div>\n    ";
                    }).join('');

                    return "\n        <div id=\"roomImages\" class=\"swiper\">\n            <div class=\"swiper-wrapper\">\n                " + slides + "\n            </div>\n            <div class=\"swiper-pagination\"></div>\n        </div>\n    ";
                }
            }, {
                key: "renderNoImagePlug",
                value: function renderNoImagePlug() {
                    return "\n            <img class=\"no-image-room\" src=\"/x-assets/img/no-image.svg\" alt=\"no-image-plug\">";
                }
            }, {
                key: "renderRoomName",
                value: function renderRoomName(name) {
                    return "<div class=\"room-name\">" + name + "</div>";
                }
            }, {
                key: "renderRoomArea",
                value: function renderRoomArea(area) {
                    if (!area) {
                        return;
                    }
                    return "<div class=\"room-area\">" + area + " \u043C<sup>2</sup></div>";
                }
            }, {
                key: "renderRoomDescription",
                value: function renderRoomDescription(description) {
                    if (!description) {
                        return;
                    }
                    return "<div class=\"room-description\">" + description.replace(/\n/g, '<br>') + "</div>";
                }
            }, {
                key: "renderLinkOnNewTour",
                value: function renderLinkOnNewTour(tourId) {
                    if (this.roomsWidgetType !== 'view-split-rooms') {
                        var a = '<a href="' + this.newTourUrl + '/' + tourId + '" class="btn btn-blue btn-select-room">Выбрать</a>';
                        return '<div class="room-modal-footer">' + a + '</div>';
                    }
                }
            }]);

            return RoomModal;
        }();

        var Rooms = function () {
            function Rooms(params) {
                _classCallCheck(this, Rooms);

                this.baseRoom = params.baseRoom ? params.baseRoom : null;
                this.newTourUrl = params.newTourUrl ? params.newTourUrl : null;
                this.loadRoomsUrl = params.loadRoomsUrl ? params.loadRoomsUrl : null;
                this.loadRoomModalContent = params.loadRoomModalContent ? params.loadRoomModalContent : null;
                this.roomsWidgetType = params.roomsWidgetType ? params.roomsWidgetType : null;

                this.roomSlider = null;
                this.roomModal = null;
                this.showLoading = true;

                this.init();
                this.handlers();
            }

            _createClass(Rooms, [{
                key: "handlers",
                value: function handlers() {
                    var _this5 = this;

                    eventDispatcher.addEventListener('_rooms-loaded', function () {
                        if (_this5.roomSlider.swiper.params) {
                            _this5.roomSlider.swiper.params.spaceBetween = 15;
                            _this5.appendRooms();
                        }
                    });

                    eventDispatcher.addEventListener('_hide-loading-rooms', function () {
                        var firstRoom = document.querySelector('#roomListSwiper .room-item.loading');

                        if (firstRoom) {
                            firstRoom.classList.remove('loading');
                        }
                    });
                }
            }, {
                key: "init",
                value: function init() {
                    this.roomSlider = new RoomsSlider({
                        roomsWidgetType: this.roomsWidgetType
                    });
                    this.roomModal = new RoomModal({
                        newTourUrl: this.newTourUrl,
                        loadRoomModalContent: this.loadRoomModalContent,
                        roomsWidgetType: this.roomsWidgetType
                    });
                    window.rooms = { 0: this.baseRoom };

                    if (this.loadRoomsUrl) {
                        this.loadRooms();
                    } else {
                        this.showLoading = false;
                        this.roomSlider.swiper.params.slidesPerView = 1;
                        this.roomSlider.swiper.update();
                    }
                }
            }, {
                key: "loadRooms",
                value: function loadRooms() {
                    var _this6 = this;

                    ajax.get(this.loadRoomsUrl, {}, function (data) {
                        /** @property AjaxResponse */
                        if (data.success) {
                            var currentLength = Object.keys(window.rooms).length;

                            // Итерируем по массиву data.responseData.rooms и добавляем каждый элемент в window.rooms
                            data.responseData.rooms.forEach(function (room, index) {
                                // Используем currentLength + index для создания нового ключа
                                window.rooms[currentLength + index] = room;
                            });
                            eventDispatcher.dispatchEvent('_rooms-loaded');
                        }

                        if (data.responseData.rooms.length === 0) {
                            _this6.roomSlider.swiper.params.slidesPerView = 1;
                        }

                        eventDispatcher.dispatchEvent('_hide-loading-rooms');
                    });
                }
            }, {
                key: "appendRooms",
                value: function appendRooms() {
                    var rooms = [];
                    for (var index in window.rooms) {
                        index = parseInt(index, 10) + 1;
                        var room = window.rooms[index];

                        if (room) {
                            rooms.push(this.renderRoom(index, room));
                        }
                    }

                    this.roomSlider.swiper.appendSlide(rooms);

                    if (rooms.length === 0) {
                        this.roomSlider.swiper.params.slidesPerView = 1;
                        this.roomSlider.swiper.update();
                    }
                }
            }, {
                key: "renderRoom",
                value: function renderRoom(index, room) {
                    var elems = [this.renderRoomHeader(room), this.renderRoomContent(room)];

                    var roomItem = '<div class="room-item">' + elems.join('') + '</div>';

                    return '<div class="swiper-slide js-toggle-room-modal" data-index="' + index + '">' + roomItem + '</div>';
                }
            }, {
                key: "renderRoomHeader",
                value: function renderRoomHeader(room) {
                    var value = '',
                        chooseRoomButton = '',
                        area = '',
                        diff = '';

                    value = '<div class="room-item__header-value">' + room.name + '</div>';

                    if (this.roomsWidgetType !== 'view-split-rooms') {
                        chooseRoomButton = '<div class="room-item__header-choose-room">Выбрать номер</div>';
                        var roomDiffLabelText = this.getRoomDiffLabel(room.diff);
                        diff = roomDiffLabelText ? '<div class="room-item__header-diff-label">' + this.getRoomDiffLabel(room.diff) + '</div>' : '';
                        if (room.detail && room.detail.area) {
                            if (parseInt(room.detail.area) !== 0) {
                                area = '<div class="room-item__header-area">' + room.detail.area + ' м<sup>2</sup></div>';
                            }
                        }
                    } else {
                        if (room.detail && room.detail.accommodation) {
                            area = room.detail.accommodation.adults + ' взрослых';
                            if (room.detail.accommodation.child > 0) {
                                var childCount = room.detail.accommodation.child > 1 ? ' детей' : ' ребенок';
                                area += ',' + room.detail.accommodation.child + childCount;
                            }
                        }
                    }

                    return '<div class="room-item__header">' + value + area + chooseRoomButton + diff + '</div>';
                }
            }, {
                key: "getRoomDiffLabel",
                value: function getRoomDiffLabel(roomDiff) {
                    var rawDiff = (roomDiff || '').toString().trim();
                    if (!rawDiff) {
                        return '';
                    }

                    var currencyMatch = rawDiff.match(/(₸|₽|€|\$|₴)/);
                    var currencySymbol = currencyMatch ? currencyMatch[1] : '₸';
                    var currencySymbolSpan = '<span class="currency">' + currencySymbol + '</span>';
                    var cleanedDiff = rawDiff.replace(/(₸|₽|€|\$|₴)/g, '').replace(/\s+/g, ' ').trim();

                    if (cleanedDiff.includes('-')) {
                        return '<span>Дешевле на ' + cleanedDiff.replace('-', '').trim() + ' ' + currencySymbolSpan + '</span>' + '<img src="/x-assets/img/icons/emoji/emoji-plot.png" alt="icon-fire">';
                    } else if (cleanedDiff.includes('+')) {
                        return '<span>' + cleanedDiff + currencySymbolSpan + '&nbsp;за улучшение</span>' + '<img src="/x-assets/img/icons/emoji/emoji-fire.png" alt="icon-fire">';
                    } else {
                        return '';
                    }
                }
            }, {
                key: "renderRoomContent",
                value: function renderRoomContent(room) {
                    var img = '<img src="/x-assets/img/no-image.svg" alt="' + room.name + '">';
                    var photosCount = '';

                    if (room.detail) {
                        if (room.detail.photos.length) {
                            img = '<img src="' + room.detail.photos[0] + '" alt="' + room.name + '">';
                            if (room.detail.photos.length > 1) {
                                photosCount = '<div class="room-item__photo-count">' + '<img src="/x-assets/img/icons/icon-photos-template.svg" alt="фото">' + room.detail.photos.length + '</div>';
                            }
                        }
                    }

                    return '<div class="room-item__content">' + img + photosCount + '</div>';
                }
            }]);

            return Rooms;
        }();

        window.Rooms = Rooms;
    }, { "./parts/_all-hotel-rooms": 1, "./parts/_room-panel": 2 }] }, {}, [3]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var MobileRoomPanel = require('./_room-panel');

        var HotelRoomInfoModal = function () {
            function HotelRoomInfoModal(params) {
                _classCallCheck(this, HotelRoomInfoModal);

                this.roomsInfo = params.rooms;
                this.eventPage = params.eventPage;

                this.roomImageSlider = null;
                this.handlers();
            }

            _createClass(HotelRoomInfoModal, [{
                key: "handlers",
                value: function handlers() {
                    var _this7 = this;

                    eventDispatcher.on('click', '.js-toggle-all-room-modal', function (event, element) {
                        var index = element.dataset.index;
                        _this7.renderModalContent(index);
                    });
                }
            }, {
                key: "getRoomInfoById",
                value: function getRoomInfoById(id) {
                    return this.roomsInfo.find(function (room) {
                        return room.id == id;
                    });
                }
            }, {
                key: "renderModalContent",
                value: function renderModalContent(index) {
                    var panel = new MobileRoomPanel(window.mobileRoomLabels);
                    panel.open(this.roomsInfo, this.roomsInfo.findIndex(function (room) {
                        return room.id == index;
                    }));
                }
            }, {
                key: "initRoomSlider",
                value: function initRoomSlider() {
                    var params = {
                        freeMode: false,
                        loop: false,
                        slidesPerView: 1,
                        pagination: {
                            el: '.swiper-pagination'
                        },
                        navigation: {
                            nextEl: null,
                            prevEl: null
                        }
                    };
                    this.roomImageSlider = new Swiper('#roomImages', params);
                }
            }, {
                key: "renderRoomImagesSlider",
                value: function renderRoomImagesSlider(photos) {
                    if (!photos || photos.length === 0) {
                        return '';
                    }
                    var slides = photos.map(function (photo) {
                        return "\n            <div class=\"swiper-slide\">\n                <img src=\"" + photo + "\" alt=\"Room Image\">\n            </div>";
                    }).join('');

                    return "\n            <div id=\"roomImages\" class=\"swiper\">\n                <div class=\"swiper-wrapper\">\n                    " + slides + "\n                </div>\n                <div class=\"swiper-pagination\"></div>\n            </div>";
                }
            }, {
                key: "renderNoImagePlug",
                value: function renderNoImagePlug() {
                    return "\n            <img class=\"no-image-room\" src=\"/x-assets/img/no-image.svg\" alt=\"no-image-plug\">";
                }
            }, {
                key: "renderRoomName",
                value: function renderRoomName(name) {
                    return "<div class=\"room-name\">" + name + "</div>";
                }
            }, {
                key: "renderRoomArea",
                value: function renderRoomArea(area) {
                    if (!area) {
                        return '';
                    }
                    return "<div class=\"room-area\">" + area + " \u043C<sup>2</sup></div>";
                }
            }, {
                key: "renderRoomDescription",
                value: function renderRoomDescription(description) {
                    if (!description) {
                        return '';
                    }
                    return "<div class=\"room-description\">" + description.replace(/\n/g, '<br>') + "</div>";
                }
            }]);

            return HotelRoomInfoModal;
        }();

        var HotelRoomsSlider = function () {
            function HotelRoomsSlider(params) {
                _classCallCheck(this, HotelRoomsSlider);

                this.roomsInfo = params.rooms;
                this.eventPage = params.eventPage;
                this.swiper = null;
                this.swipeCount = 0;
                this.init();
            }

            _createClass(HotelRoomsSlider, [{
                key: "init",
                value: function init() {
                    var self = this;
                    var params = {
                        lazy: true,
                        preloadImages: false,
                        loadOnTransitionStart: true,
                        lazyPreloadPrevNext: 2,
                        freeMode: false,
                        loop: false,
                        slidesPerView: 1.3,
                        spaceBetween: 20,
                        navigation: {
                            nextEl: null,
                            prevEl: null
                        },
                        breakpoints: {
                            500: {
                                slidesPerView: 2.3
                            },
                            650: {
                                slidesPerView: 2.6
                            },
                            800: {
                                slidesPerView: 3.3
                            }
                        },
                        on: {
                            slideChange: function slideChange() {
                                var eventProperties = {};
                                eventProperties['Page'] = self.eventPage;
                                window.brxTracking.sendAnalyticsEvent('scroll_hotel_rooms', eventProperties);
                                this.off('slideChange');
                            },
                            click: function click() {
                                var eventProperties = {};
                                eventProperties['Page'] = self.eventPage;
                                window.brxTracking.sendAnalyticsEvent('click_hotel_room_type', eventProperties);
                                this.off('click');
                            }
                        }
                    };
                    this.swiper = new Swiper('#hotelRoomsSwiper', params);

                    this.hotelRoomInfoModal = new HotelRoomInfoModal({
                        rooms: this.roomsInfo,
                        eventPage: this.eventPage
                    });
                }
            }]);

            return HotelRoomsSlider;
        }();

        window.HotelRoomsSlider = HotelRoomsSlider;
    }, { "./_room-panel": 2 }], 2: [function (require, module, exports) {
        /* jshint esversion: 6 */
        var MobileRoomPanel = function () {
            function MobileRoomPanel(labels) {
                _classCallCheck(this, MobileRoomPanel);

                this.labels = labels;
            }

            _createClass(MobileRoomPanel, [{
                key: "element",
                value: function element(tag, className) {
                    var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

                    var node = document.createElement(tag);
                    node.className = className;node.textContent = text;return node;
                }
            }, {
                key: "open",
                value: function open(variants, selectedIndex) {
                    var _this8 = this;

                    var bookingUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    var split = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

                    var root = this.element('div', 'mobile-room-panel');
                    var navigation = this.element('div', 'mobile-room-panel__tabs');
                    navigation.setAttribute('role', 'tablist');
                    navigation.setAttribute('aria-label', this.labels.title);
                    variants.forEach(function (variant, index) {
                        var option = _this8.element('button', 'mobile-room-panel__tab', variant.name);
                        option.type = 'button';
                        option.setAttribute('role', 'tab');
                        option.addEventListener('click', function () {
                            return show(index, true);
                        });
                        navigation.appendChild(option);
                    });
                    var body = this.element('div', 'mobile-room-panel__body');
                    var action = bookingUrl && !split ? this.element('div', 'mobile-room-panel__action') : null;
                    root.appendChild(navigation);root.appendChild(body);
                    var gallery = null,
                        modal = null,
                        activeIndex = null;
                    var show = function show(index) {
                        var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                        if (activeIndex === index) return;
                        if (animate) {
                            var _variant2 = variants[index];
                            if (window.brxTracking) window.brxTracking.sendAnalyticsEvent('hotel_room_change', Object.assign({}, window.app && window.app.pageParams, {
                                context: bookingUrl ? 'booking' : 'hotel', room_id: _variant2.detail ? _variant2.detail.id : _variant2.id,
                                tour_id: _variant2.tourId, room_index: index
                            }));
                        }
                        activeIndex = index;
                        if (gallery) {
                            gallery.destroy(true, true);gallery = null;
                        }
                        Array.from(navigation.children).forEach(function (tab, tabIndex) {
                            tab.setAttribute('aria-selected', String(tabIndex === index));
                        });
                        var activeTab = navigation.children[index];
                        var tabInset = parseFloat(window.getComputedStyle(navigation).paddingLeft);
                        navigation.scrollTo({
                            left: navigation.scrollLeft + activeTab.getBoundingClientRect().left - navigation.getBoundingClientRect().left - tabInset,
                            behavior: animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
                        });
                        body.replaceChildren();
                        var variant = variants[index];
                        var room = bookingUrl || split ? variant.detail : variant;
                        var card = _this8.element('article', 'mobile-room-panel__card');
                        var heading = _this8.element('div', 'mobile-room-panel__heading');
                        var title = _this8.element('div', 'mobile-room-panel__title');
                        title.appendChild(_this8.element('h2', '', variant.name));
                        if (room && room.area) title.appendChild(_this8.element('p', 'mobile-room-panel__area', room.area + ' ' + _this8.labels.area));
                        heading.appendChild(title);
                        if (action && index === 0) {
                            heading.appendChild(_this8.element('span', 'mobile-room-panel__current', _this8.labels.selected));
                        }
                        if (action && index !== 0 && variant.diff) {
                            heading.appendChild(_this8.element('strong', 'mobile-room-panel__price', variant.diff));
                        }
                        card.appendChild(heading);
                        var slider = void 0;
                        if (room && room.photos && room.photos.length) {
                            slider = _this8.element('div', 'swiper mobile-room-panel__gallery');
                            var slides = _this8.element('div', 'swiper-wrapper');
                            room.photos.forEach(function (src) {
                                var slide = _this8.element('div', 'swiper-slide');
                                var image = _this8.element('img', '');image.src = src;image.alt = variant.name;image.loading = 'lazy';
                                slide.appendChild(image);slides.appendChild(slide);
                            });
                            slider.appendChild(slides);slider.appendChild(_this8.element('div', 'swiper-pagination'));
                            card.appendChild(slider);
                        }
                        if (room) {
                            var services = (room.services || []).filter(function (service) {
                                return service.value && !/^(нет|no|false|0)$/i.test(String(service.value).trim());
                            });
                            var description = room.description || '';
                            if (services.length) description = description.split(/Удобства в номере\s*:/i)[0].trim();
                            if (description) card.appendChild(_this8.element('div', 'mobile-room-panel__description', description));
                            _this8.appendServices(card, services, _this8.labels.amenities);
                            var additional = Object.values(room.additionalServices || {}).map(function (name) {
                                return { name: name, value: 'есть' };
                            });
                            _this8.appendServices(card, additional, _this8.labels.additional);
                        }
                        body.appendChild(card);
                        if (action) {
                            action.replaceChildren();
                            action.hidden = index === 0;
                            if (index !== 0) {
                                var link = _this8.element('a', 'btn btn-blue btn-select-room', _this8.labels.select);
                                link.href = bookingUrl + '/' + encodeURIComponent(variant.tourId) + window.location.search;
                                action.appendChild(link);
                            }
                        }
                        if (slider) gallery = new Swiper(slider, { slidesPerView: 1, pagination: { el: slider.querySelector('.swiper-pagination'), type: 'fraction' } });
                        if (modal) modal.querySelector('.modal2-body').scrollTop = 0;
                    };
                    window.modal.open({
                        header: { title: this.labels.title, theme: window.modal.themes.PRIMARY },
                        type: 'full', footer: false, parentCssClass: 'mobile-room-panel-modal', content: { html: root },
                        onAfterShow: function onAfterShow(element) {
                            modal = element;
                            if (action) modal.querySelector('.modal2-content').appendChild(action);
                            show(selectedIndex);
                        },
                        onBeforeRemove: function onBeforeRemove() {
                            if (gallery) gallery.destroy(true, true);
                        }
                    });
                }
            }, {
                key: "appendServices",
                value: function appendServices(card, services, title) {
                    var _this9 = this;

                    if (!services.length) return;
                    var section = this.element('section', 'mobile-room-panel__services');
                    section.appendChild(this.element('h3', '', title));
                    var list = this.element('ul', 'mobile-room-panel__list');
                    services.forEach(function (service) {
                        var row = _this9.element('li', 'mobile-room-panel__service');
                        row.appendChild(_this9.element('span', '', service.name));
                        var value = String(service.value).trim();
                        if (/^(платно|бесплатно)$/i.test(value)) {
                            var paid = value.toLowerCase() === 'платно';
                            row.appendChild(_this9.element('span', 'mobile-room-panel__badge' + (paid ? ' mobile-room-panel__badge--paid' : ''), paid ? _this9.labels.paid : _this9.labels.free));
                        } else if (!/^(есть|yes|true|1)$/i.test(value)) {
                            row.appendChild(_this9.element('span', 'mobile-room-panel__value', value));
                        }
                        list.appendChild(row);
                    });
                    section.appendChild(list);
                    card.appendChild(section);
                }
            }]);

            return MobileRoomPanel;
        }();

        module.exports = MobileRoomPanel;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */
        var MobileRoomPanel = function () {
            function MobileRoomPanel(labels) {
                _classCallCheck(this, MobileRoomPanel);

                this.labels = labels;
            }

            _createClass(MobileRoomPanel, [{
                key: "element",
                value: function element(tag, className) {
                    var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

                    var node = document.createElement(tag);
                    node.className = className;node.textContent = text;return node;
                }
            }, {
                key: "open",
                value: function open(variants, selectedIndex) {
                    var _this10 = this;

                    var bookingUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    var split = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

                    var root = this.element('div', 'mobile-room-panel');
                    var navigation = this.element('div', 'mobile-room-panel__tabs');
                    navigation.setAttribute('role', 'tablist');
                    navigation.setAttribute('aria-label', this.labels.title);
                    variants.forEach(function (variant, index) {
                        var option = _this10.element('button', 'mobile-room-panel__tab', variant.name);
                        option.type = 'button';
                        option.setAttribute('role', 'tab');
                        option.addEventListener('click', function () {
                            return show(index, true);
                        });
                        navigation.appendChild(option);
                    });
                    var body = this.element('div', 'mobile-room-panel__body');
                    var action = bookingUrl && !split ? this.element('div', 'mobile-room-panel__action') : null;
                    root.appendChild(navigation);root.appendChild(body);
                    var gallery = null,
                        modal = null,
                        activeIndex = null;
                    var show = function show(index) {
                        var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                        if (activeIndex === index) return;
                        if (animate) {
                            var _variant3 = variants[index];
                            if (window.brxTracking) window.brxTracking.sendAnalyticsEvent('hotel_room_change', Object.assign({}, window.app && window.app.pageParams, {
                                context: bookingUrl ? 'booking' : 'hotel', room_id: _variant3.detail ? _variant3.detail.id : _variant3.id,
                                tour_id: _variant3.tourId, room_index: index
                            }));
                        }
                        activeIndex = index;
                        if (gallery) {
                            gallery.destroy(true, true);gallery = null;
                        }
                        Array.from(navigation.children).forEach(function (tab, tabIndex) {
                            tab.setAttribute('aria-selected', String(tabIndex === index));
                        });
                        var activeTab = navigation.children[index];
                        var tabInset = parseFloat(window.getComputedStyle(navigation).paddingLeft);
                        navigation.scrollTo({
                            left: navigation.scrollLeft + activeTab.getBoundingClientRect().left - navigation.getBoundingClientRect().left - tabInset,
                            behavior: animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
                        });
                        body.replaceChildren();
                        var variant = variants[index];
                        var room = bookingUrl || split ? variant.detail : variant;
                        var card = _this10.element('article', 'mobile-room-panel__card');
                        var heading = _this10.element('div', 'mobile-room-panel__heading');
                        var title = _this10.element('div', 'mobile-room-panel__title');
                        title.appendChild(_this10.element('h2', '', variant.name));
                        if (room && room.area) title.appendChild(_this10.element('p', 'mobile-room-panel__area', room.area + ' ' + _this10.labels.area));
                        heading.appendChild(title);
                        if (action && index === 0) {
                            heading.appendChild(_this10.element('span', 'mobile-room-panel__current', _this10.labels.selected));
                        }
                        if (action && index !== 0 && variant.diff) {
                            heading.appendChild(_this10.element('strong', 'mobile-room-panel__price', variant.diff));
                        }
                        card.appendChild(heading);
                        var slider = void 0;
                        if (room && room.photos && room.photos.length) {
                            slider = _this10.element('div', 'swiper mobile-room-panel__gallery');
                            var slides = _this10.element('div', 'swiper-wrapper');
                            room.photos.forEach(function (src) {
                                var slide = _this10.element('div', 'swiper-slide');
                                var image = _this10.element('img', '');image.src = src;image.alt = variant.name;image.loading = 'lazy';
                                slide.appendChild(image);slides.appendChild(slide);
                            });
                            slider.appendChild(slides);slider.appendChild(_this10.element('div', 'swiper-pagination'));
                            card.appendChild(slider);
                        }
                        if (room) {
                            var services = (room.services || []).filter(function (service) {
                                return service.value && !/^(нет|no|false|0)$/i.test(String(service.value).trim());
                            });
                            var description = room.description || '';
                            if (services.length) description = description.split(/Удобства в номере\s*:/i)[0].trim();
                            if (description) card.appendChild(_this10.element('div', 'mobile-room-panel__description', description));
                            _this10.appendServices(card, services, _this10.labels.amenities);
                            var additional = Object.values(room.additionalServices || {}).map(function (name) {
                                return { name: name, value: 'есть' };
                            });
                            _this10.appendServices(card, additional, _this10.labels.additional);
                        }
                        body.appendChild(card);
                        if (action) {
                            action.replaceChildren();
                            action.hidden = index === 0;
                            if (index !== 0) {
                                var link = _this10.element('a', 'btn btn-blue btn-select-room', _this10.labels.select);
                                link.href = bookingUrl + '/' + encodeURIComponent(variant.tourId) + window.location.search;
                                action.appendChild(link);
                            }
                        }
                        if (slider) gallery = new Swiper(slider, { slidesPerView: 1, pagination: { el: slider.querySelector('.swiper-pagination'), type: 'fraction' } });
                        if (modal) modal.querySelector('.modal2-body').scrollTop = 0;
                    };
                    window.modal.open({
                        header: { title: this.labels.title, theme: window.modal.themes.PRIMARY },
                        type: 'full', footer: false, parentCssClass: 'mobile-room-panel-modal', content: { html: root },
                        onAfterShow: function onAfterShow(element) {
                            modal = element;
                            if (action) modal.querySelector('.modal2-content').appendChild(action);
                            show(selectedIndex);
                        },
                        onBeforeRemove: function onBeforeRemove() {
                            if (gallery) gallery.destroy(true, true);
                        }
                    });
                }
            }, {
                key: "appendServices",
                value: function appendServices(card, services, title) {
                    var _this11 = this;

                    if (!services.length) return;
                    var section = this.element('section', 'mobile-room-panel__services');
                    section.appendChild(this.element('h3', '', title));
                    var list = this.element('ul', 'mobile-room-panel__list');
                    services.forEach(function (service) {
                        var row = _this11.element('li', 'mobile-room-panel__service');
                        row.appendChild(_this11.element('span', '', service.name));
                        var value = String(service.value).trim();
                        if (/^(платно|бесплатно)$/i.test(value)) {
                            var paid = value.toLowerCase() === 'платно';
                            row.appendChild(_this11.element('span', 'mobile-room-panel__badge' + (paid ? ' mobile-room-panel__badge--paid' : ''), paid ? _this11.labels.paid : _this11.labels.free));
                        } else if (!/^(есть|yes|true|1)$/i.test(value)) {
                            row.appendChild(_this11.element('span', 'mobile-room-panel__value', value));
                        }
                        list.appendChild(row);
                    });
                    section.appendChild(list);
                    card.appendChild(section);
                }
            }]);

            return MobileRoomPanel;
        }();

        module.exports = MobileRoomPanel;
    }, {}] }, {}, [1]);